import request from '../../../axios';

const PostAddChat = async (payload: IPayloadPostAddChat) => {
  const {data}: {data: IPostAddChatData} = await request.post(
    `/api/v2/shop/chat`,
    payload,
  );
  return data;
};

export default PostAddChat;
